import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { getDemoStats } from 'api/salesAnalytics/getDemoStats';

interface DemoStatsGraphProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

const DemoStatsGraph: React.FC<DemoStatsGraphProps> = ({ startDate, endDate }) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // fetch sales stats on start date and end date change
  useEffect(() => {
    const fetchDemoStats = async () => {
      if (startDate && endDate) {
        try {
          setLoading(true);
          console.log('Fetching email stats with:', { startDate, endDate });
          const response = await getDemoStats(startDate.toDate(), endDate.toDate());
          console.log('API Response:', response);
          setChartData(response || []);
        } catch (error) {
          console.error('Error fetching email stats:', error);
        } finally {
          setLoading(false);
        }
      } else {
        console.warn('Start date or end date is null. Skipping API call.');
      }
    };

    fetchDemoStats();
  }, [startDate, endDate]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    // Set a fixed height (300px) to prevent the graph from growing vertically indefinitely.
    <Box sx={{ width: '100%', height: 300 }}>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis
              label={{
                value: 'demos',
                angle: -90,
                position: 'insideLeft',
                offset: -10,
              }}
            />
            <Tooltip />
            <Legend />
            <Bar dataKey="demoMeetings" fill="#8FBFDA" />
            <Bar dataKey="received" fill="#67778a" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography align="center">No data available</Typography>
      )}
    </Box>
  );
};

export default DemoStatsGraph;
